import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { AccessControlService } from './access-control.service';

@NgModule({
    declarations: [],
    imports: [CommonModule],
})
export class AccessControlModule {
    static forRoot(): ModuleWithProviders<AccessControlModule> {
        return {
            ngModule: AccessControlModule,
            providers: [AccessControlService],
        };
    }
}
